import React, { useState } from 'react';
import { hasScopesPermission } from '@tribeplatform/gql-client/lib';
import { CreateSpaceFromTemplateModal as CreateSpaceModal } from '@tribeplatform/react-components/Space';
import { useCollections, useNetwork } from '@tribeplatform/react-sdk/hooks';
import { CollectionsLoading } from './CollectionLoading.js';
import { CollectionMenuCollapsible } from './CollectionMenuCollapsible.js';
import { CollectionMenuHeading } from './CollectionMenuHeading.js';
import { CollectionMenuSimple } from './CollectionMenuSimple.js';
import { CollectionMenuViewStyle } from './types.js';
import { getOrderedCollections } from './utils.js';
export const CollectionMenuBlock = ({ items, viewStyle, }) => {
    const [createSpaceModal, setCreateSpaceModal] = useState(null);
    const { data: network = {} } = useNetwork();
    const { data: collections, isLoading } = useCollections({
        fields: {
            space: viewStyle === CollectionMenuViewStyle.Simple
                ? {}
                : {
                    image: 'basic',
                    banner: 'basic',
                    slate: 'all',
                    authMemberProps: {},
                },
        },
        variables: {},
        useQueryOptions: {
            retry: 10,
            retryDelay: 1000,
        },
    });
    const [canCreateSpace] = hasScopesPermission(network, ['addSpace']);
    if (!Array.isArray(collections) || isLoading)
        return React.createElement(CollectionsLoading, null);
    const orderedCollections = getOrderedCollections(items, collections);
    let CollectionMenuComponent = null;
    if (viewStyle === CollectionMenuViewStyle.Simple)
        CollectionMenuComponent = (React.createElement(CollectionMenuSimple, { collections: orderedCollections }));
    else if (viewStyle === CollectionMenuViewStyle.Collapsible)
        CollectionMenuComponent = (React.createElement(CollectionMenuCollapsible, { canCreateSpace: canCreateSpace, collections: orderedCollections, createSpace: setCreateSpaceModal }));
    else if (viewStyle === CollectionMenuViewStyle.Heading)
        CollectionMenuComponent = (React.createElement(CollectionMenuHeading, { canCreateSpace: canCreateSpace, collections: orderedCollections, createSpace: setCreateSpaceModal }));
    return (React.createElement(React.Fragment, null,
        CollectionMenuComponent,
        createSpaceModal ? (React.createElement(CreateSpaceModal, { open: true, space: createSpaceModal, onClose: () => {
                setCreateSpaceModal(null);
            } })) : null));
};
//# sourceMappingURL=Block.js.map